<template>
  <div id="app">
    {{ getQuote() }}
    <div class="background-image"></div>
    <div class="container">
      <p class="quote"> <q>{{ quote }}</q></p>
      <br>
      <h3 class="author">- {{ author }}</h3>
      <br><br>
      <!-- <div class="button">
      <button class="beautiful-button">Click me</button>
    </div> -->
      <button class="button-74" @click="reloadPage" role="button">get inspired!</button>
    </div>

  </div>
</template>

<script>
// import axios from 'axios'
import quotes from '../assets/quotes.json'
export default {
  name: 'HelloWorld',
  data() {
    return {
      allQuotes: quotes,
      quote: 'smile is the best way to beat your enemies',
      author: 'suditya '
    }
  },
  methods:
  {
    getQuote() {
      // console.log("quotes",this.allQuotes)
      const ele = this.allQuotes[Math.floor(Math.random() * this.allQuotes.length)];
      this.quote = ele.text;
      this.author = ele.author;
    },
    reloadPage() {
      window.location.reload();
    }
  }

}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* CSS */
.button-74 {
  background-color: #fbeee0;
  border: 2px solid #422800;
  border-radius: 30px;
  box-shadow: #422800 4px 4px 0 0;
  color: #422800;
  cursor: pointer;
  display: inline-block;
  font-weight: 600;
  font-size: 18px;
  padding: 0 18px;
  line-height: 50px;
  text-align: center;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.button-74:hover {
  background-color: #fff;
}

.button-74:active {
  box-shadow: #422800 2px 2px 0 0;
  transform: translate(2px, 2px);
}

@media (min-width: 768px) {
  .button-74 {
    min-width: 120px;
    padding: 0 25px;
  }
}

* {
  margin: 0;
  padding: 0;

}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('https://source.unsplash.com/random');
  /* background-image: url('https://giphy.com/embed/CGZGV8wix4lvJn3dxy'); */
  background-size: cover;

}

.quote {
  font-family: cursive;
  font-size: 30px;
  font-weight: 500;
}

.author {
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  font-size: 25px;
}

/* Container */
.container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  border: 3px solid white;
  border-radius: 15px;
  padding: 70px;
  color: white;
  box-shadow: 11px 7px 3px 1px rgb(6 6 6 / 20%);
  /* box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  background-color:rgb(50, 47, 47); */
  background: linear-gradient(to right, black, grey, rgb(161, 140, 140), black);
  background: linear-gradient(to right, #0000004a, grey, rgb(161, 140, 140), #0000005c)
  /* Animation */
}

.button {
  z-index: 100;
}

.beautiful-button {
  /* Button Style */
  background-color: #4CAF50;
  /* Green */
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  /* Box Shadow */
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  /* Border Radius */
  border-radius: 12px;
  /* Transition */
  transition: all 0.3s ease-in-out;
}

/* Hover Effect */
.beautiful-button:hover {
  background-color: #3e8e41;
  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.24), 0 17px 50px 0 rgba(0, 0, 0, 0.19);
}
@media screen and (max-width:500px) 
{
  .button-74
  {
    font-size: 10px;
    padding: 8px;
  } 
  .quote
  {
    font-size: 35px;
  }
  .author
  {
    font-size: 10px;
  }
  .container
  {
    padding: 40px;
    width: 65%;
    top: 40%;
  }
}
</style>
